import { BOOKING_ERROR_CODES } from '@shared/core/bookings'
import { TOO_MANY_REQUESTS_ERROR } from 'src/modules/core/constants/errorCodes'

export function isTooManyRequestsError(error: unknown): boolean {
  const response = (error as { response?: { status?: unknown; data?: { code?: unknown } } })?.response
  return response?.status === TOO_MANY_REQUESTS_ERROR || response?.data?.code === BOOKING_ERROR_CODES.tooManyRequests
}
